import React from 'react';
import zh from '../../locales/zh-Hans.json';
import en from '../../locales/en-US.json';
import urlparser from 'urlparser';
import PCInputEmail from '../../components/PCInputEmail/PCInputEmail';
import PCOpenSuccess from '../../components/PCInputEmail/PCOpenSuccess';
import PCInputPhone from '../../components/PCInputPhone/PCInputPhone';
import PCOpenPhoneSuccess from '../../components/PCInputPhone/PCOpenPhoneSuccess';
import ReactGA from 'react-ga';
import { Button } from 'antd';
import './index.scss'
import moment from 'moment';

export interface IPCProps {
  logo: string,
  inviterId: string;
  trailId: string;
  qrcode:string;
  activityTime:any;
  privilegesDays:any;
  description:any;
  userRegisterType:any;
  state:any;
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  trailId: string;
  showVip: string;
  inputEmail: boolean;
  openSuccess: boolean;
  qrcode:string;
  activityTime:any;
  description:any;
  privilegesDays:any;
  userRegisterType:any;
  state:any;
}

class PCModal extends React.Component<IPCProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    inviterId: '',
    trailId: '',
    showVip: 'personal',
    inputEmail: false,
    openSuccess: false,
    qrcode:'',
    activityTime:{},
    description:'',
    privilegesDays:'',
    userRegisterType:'',
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({ lang: 'en-US' });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId: this.props.trailId,
        logo: this.props.logo,
        inviterId: this.props.inviterId,
        qrcode:this.props.qrcode,
        activityTime:this.props.activityTime,
        description:this.props.description,
        privilegesDays:this.props.privilegesDays,
        userRegisterType:this.props.userRegisterType,
        state:this.props.state
      });
  }

  render() {
    const { showVip, inputEmail, openSuccess, trailId, inviterId, time, logo,qrcode,description,activityTime,privilegesDays,userRegisterType,state } = this.state;
    return (
      <div className='pc-modal'>
        <div className='pc-modal-content'>
          <div className='pc-modal-content-left-first'>
            <div className='pc-modal-content-left-logo'>
              <img src={require('../../assets/pc-modal/logo.svg')} alt=""/>
              {
                logo ? <img style={{margin:'0 16px'}} src={require('../../assets/pc-modal/with.svg')} alt=""/> : null
              }
              {
                logo ? <img src={logo} style={{ width: '106px', height: '30px' }} alt=""/> : null
              }
            </div>
            {
              description? <div className='pc-modal-content-left-item-two'>
                {description}
              </div>:null
            }
            <div className='pc-modal-content-left-item-one'>
              为你节约 90% 的 PPT 制作时间
            </div>
            {
              activityTime.startAt&&activityTime.endAt?<div className={'pc-modal-content-left-item-time'}>
                {moment(activityTime.startAt*1000).format('YYYY.MM.DD')} - {moment(activityTime.endAt*1000).format('YYYY.MM.DD')}
              </div>:null
            }
            <div className='pc-modal-content-left-item-four'>
              <div className='pc-modal-content-left-four-button-one' onClick={()=>window.open('https://www.islide.cc/download')}><img
                src={require('../../assets/pc-modal/windows.svg')}  alt=""/>Windows
              </div>
              <div className='pc-modal-content-left-four-button-two' onClick={()=>window.open('https://www.islide.cc/download')}><img
                src={require('../../assets/pc-modal/apple.svg')} alt=""/>mac OS
              </div>
            </div>
          </div>
          <div className='pc-modal-content-right-first'>
            <img src={require('../../assets/pc-modal/rightOne.png')} alt=""/>
          </div>
        </div>
        <div className='pc-modal-single-bc'/>
        <div className='pc-modal-content pc-modal-content-two'>
          <div className='pc-modal-content-left-two'>
            <div className='pc-modal-content-left-item-one'>
              iSlide 是什么
            </div>
            <div className='pc-modal-content-left-item-two'>
              一款基于 PPT（兼容 Office 和 WPS ）的插件工具，即便你不懂设计，也能高效创建专业演示文档，已成为近千万用户必备的生产力工具！
            </div>
            <div className='pc-modal-content-left-item-three'>
              <div className='pc-modal-content-left-item-three-item'>
                <div className='pc-modal-content-left-item-three-item-head'>8<span className='pc-modal-content-left-item-three-item-head-special'>大</span></div>
                <div className='pc-modal-content-left-item-three-item-content'>在线资源库</div>
              </div>
              <div className='pc-modal-content-left-item-three-item'>
                <div className='pc-modal-content-left-item-three-item-head'>30<span className='pc-modal-content-left-item-three-item-head-special'>万+</span></div>
                <div className='pc-modal-content-left-item-three-item-content'>专业 PPT 模板</div>
              </div>
              <div className='pc-modal-content-left-item-three-item'>
                <div className='pc-modal-content-left-item-three-item-head'>38<span className='pc-modal-content-left-item-three-item-head-special'>个</span></div>
                <div className='pc-modal-content-left-item-three-item-content'>设计辅助功能</div>
              </div>
            </div>
          </div>
          <div className='pc-modal-content-right-two'>
            <img src={require('../../assets/pc-modal/rightTwo.png')} alt=""/>
          </div>
        </div>
        <div className='pc-modal-content-box'>
          <div className='pc-modal-content pc-modal-content-three-box'>
            <div className='pc-modal-content-three'>
              <span className='pc-modal-content-three-head-left'>iSlide 会员权益</span>
              <span className='pc-modal-content-three-head-right'><span
                style={showVip === 'personal' ? { color: '#F42521' } : {}} onClick={()=>{this.setState({showVip:'personal'})}}>个人</span><span
                style={showVip !== 'personal' ? { color: '#F42521' } : {}} onClick={()=>{this.setState({showVip:'enterprise'})}}>企业</span></span>
            </div>
            <div className='pc-modal-content-intros-box'>
            {
              showVip === 'personal'
                ? <div className='pc-modal-content-intros'>
                  {
                    personIntros.map(item => {
                      return <div className='pc-modal-content-intro-item' key={item.title}>
                        <img className='pc-modal-content-intro-item-img' src={item.img} alt=""/>
                        <span className='pc-modal-content-intro-item-one'>{item.title}</span>
                        <span className='pc-modal-content-intro-item-two'>{item.content}</span>
                      </div>;
                    })
                  }
                </div> : <div className='pc-modal-content-intros'>
                  {
                    enterpriseIntros.map(item => {
                      return <div className='pc-modal-content-intro-item' key={item.title}>
                        <img className='pc-modal-content-intro-item-img' src={item.img} alt=""/>
                        <span className='pc-modal-content-intro-item-one'>{item.title}</span>
                        <span className='pc-modal-content-intro-item-two'>{item.content}</span>
                      </div>;
                    })
                  }
                </div>
            }
            </div>
          </div>
        </div>
        <div className='pc-modal-content pc-modal-content-four'>
          <div className='pc-modal-content-four-head'>领取方式</div>
          <div className='pc-modal-content-left-four'>
            <p>1、填写{userRegisterType==='phone'?'手机号':'邮箱'}注册，领取 iSlide 个人 {privilegesDays} 天会员体验；</p>
            <p>2、查阅“会员开通{userRegisterType==='phone'?'短信':'邮件'}”，获取账号与密码；</p>
            <p>3、下载并安装 iSlide 插件（<span onClick={()=>window.open('https://www.islide.cc')}>islide.cc</span>），使用“会员开通{userRegisterType==='phone'?'短信':'邮件'}”中的账号密码登录，即可获得相应会员权益。</p>
          </div>
          {
            qrcode?<div className='pc-modal-content-right-four'>
              <img src={require('../../assets/pc-modal/rightThree.png')} alt=""/>
              <p>关注 iSlide 领取更多福利</p>
            </div>:null
          }
        </div>
        <div className='pc-modal-content-bottom-box'>
        <div className='pc-modal-content-bottom'>
          <span className='pc-modal-content-bottom-left'>你和 PPT 高手之间，就只差一个 iSlide</span>
          <Button className='pc-modal-content-bottom-right' type={'primary'}
                  onClick={() => this.setState({ inputEmail: true })}>立即领取</Button>
        </div>
        </div>
        {
          userRegisterType==='phone'?<PCInputPhone visible={inputEmail} onClose={(e: any, time?: any) => {
            this.setState({ inputEmail: false });
            if (e === true) {
              ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/email/success`);
              this.setState({ openSuccess: true, time: time });
            }
          }} trailId={trailId} inviterId={inviterId} state={state}/>:<PCInputEmail visible={inputEmail} onClose={(e: any, time?: any) => {
            this.setState({ inputEmail: false });
            if (e === true) {
              ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/phone/success`);
              this.setState({ openSuccess: true, time: time });
            }
          }} trailId={trailId} inviterId={inviterId} state={state}/>
        }
        {
          userRegisterType==='phone'?<PCOpenPhoneSuccess visible={openSuccess} time={time} onClose={() => this.setState({ openSuccess: false })}/>:<PCOpenSuccess visible={openSuccess} time={time} onClose={() => this.setState({ openSuccess: false })}/>
        }
      </div>
    );
  }
}

export default PCModal;
const personIntros = [
  {
    img: require('../../assets/pc-modal/intro13.svg'),
    title: 'VIP 资源',
    content: '解锁黄标资源'
  },
  {
    img: require('../../assets/pc-modal/intro14.svg'),
    title: '海量下载',
    content: '30 万+常用素材'
  },
  {
    img: require('../../assets/pc-modal/intro15.svg'),
    title: '正版保障',
    content: '原创正版模板'
  },
  {
    img: require('../../assets/pc-modal/intro16.svg'),
    title: '授权',
    content: '个人使用授权'
  },
  {
    img: require('../../assets/pc-modal/intro17.svg'),
    title: '更新',
    content: '资源持续更新'
  },
  {
    img: require('../../assets/pc-modal/intro18.svg'),
    title: '用户上传',
    content: '用户资源上传'
  }
];
const enterpriseIntros = [
  {
    img: require('../../assets/pc-modal/intro1.svg'),
    title: '视觉中国',
    content: '海量正版图片'
  },
  {
    img: require('../../assets/pc-modal/intro2.svg'),
    title: 'VIP 资源',
    content: '解锁黄标资源'
  },
  {
    img: require('../../assets/pc-modal/intro3.svg'),
    title: '正版保障',
    content: '原创正版模板'
  },
  {
    img: require('../../assets/pc-modal/intro4.svg'),
    title: '海量下载',
    content: '30 万+常用素材'
  },
  {
    img: require('../../assets/pc-modal/intro5.svg'),
    title: '授权',
    content: '企业商用授权'
  },
  {
    img: require('../../assets/pc-modal/intro6.svg'),
    title: '权益证书',
    content: '授权证书下载'
  },
  {
    img: require('../../assets/pc-modal/intro7.svg'),
    title: '尊享蓝标',
    content: '蓝标原创模板'
  },
  {
    img: require('../../assets/pc-modal/intro8.svg'),
    title: '更新',
    content: '资源持续更新'
  },
  {
    img: require('../../assets/pc-modal/intro9.svg'),
    title: '用户上传',
    content: '用户资源上传'
  },
  {
    img: require('../../assets/pc-modal/intro10.svg'),
    title: '子账号',
    content: '多人同时使用'
  },
  {
    img: require('../../assets/pc-modal/intro11.svg'),
    title: '专票',
    content: '企业报销无忧'
  },
  {
    img: require('../../assets/pc-modal/intro12.svg'),
    title: '独立客服',
    content: '企业专属顾问'
  }
];
